'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = getConfigurationSaga;

var _effects = require('redux-saga/effects');

var _reduceConfiguration = require('../../actions/context/reduceConfiguration');

var _reduceConfiguration2 = _interopRequireDefault(_reduceConfiguration);

var _selectSubfolderPrefix = require('../../selectors/context/selectSubfolderPrefix');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getConfigurationSaga);

function getConfigurationSaga() {
	var subfolderPrefix, response, configuration;
	return regeneratorRuntime.wrap(function getConfigurationSaga$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _effects.select)((0, _selectSubfolderPrefix.selectSubfolderPrefix)());

				case 2:
					subfolderPrefix = _context.sent;
					_context.next = 5;
					return (0, _effects.call)(fetch, subfolderPrefix + '/api/context/configuration');

				case 5:
					response = _context.sent;
					_context.next = 8;
					return (0, _effects.call)([response, 'json']);

				case 8:
					configuration = _context.sent;
					_context.next = 11;
					return (0, _effects.put)((0, _reduceConfiguration2.default)(_extends({}, configuration.coveraHelper, configuration.coveraWebHelper, configuration.userInterface || {})));

				case 11:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this);
}